export default {
  title: 'Kiitos, että lähetit tietosi maksujen vastaanottamista varten',
  description:
    'Stripen tarkistus voi kestää jopa 48 tuntia. Sillä välin voit jatkaa seuraaviin vaiheisiin. Ilmoitamme sähköpostitse heti, kun tietosi on vahvistettu.',
};
